import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface DeleteRequestDialogData {
    count: number;
}

@Component({
    selector: 'app-delete-request-dialog',
    templateUrl: './delete-request-dialog.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeleteRequestDialogComponent {
    private dialogRef = inject<MatDialogRef<DeleteRequestDialogComponent>>(MatDialogRef);
    private data = inject<DeleteRequestDialogData>(MAT_DIALOG_DATA);

    protected heading = computed(() =>
        this.data.count > 1 ? 'common.delete-requests-dialog.title' : 'common.delete-request-dialog.title'
    );

    protected description = computed(() =>
        this.data.count > 1 ? 'common.delete-requests-dialog.description' : 'common.delete-request-dialog.description'
    );

    protected onConfirm(): void {
        this.dialogRef.close(true);
    }

    protected onCancel(): void {
        this.dialogRef.close(false);
    }
}
